export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10363.0efd9823.jpg";